/*
 * File: FancyDateRangePicker.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 17 Dec 2021 3:19:59 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { DatePicker } from 'antd';
import { InlineStylesModel } from 'models/InlineStylesModel';
import { FC, useRef, useState } from 'react';

interface FancyDateRangePickerProps {
  rangeValues: string[];
  placeHolder: string;
  disabled?: boolean;
  width?: number;
  format?: string;
  onInputChange: (_date: unknown, dateStrings: [string, string]) => void;
  onCalendarChange: (_dates: unknown, dateStrings: [string, string], info: { range: unknown | unknown }) => void;
  defaultValue?: string;
}

const styles: InlineStylesModel = {
  form: {
    position: 'relative'
  },
  borderAnimation: {
    // transform: 'translateX(-100%)',
    transition: 'all 0.3s ease'
  },
  input: {
    width: '100%',
    minWidth: 125
  },
  labelUnfocused: {
    position: 'absolute',
    color: 'rgba(0,0,0,0.50)',
    top: 5,
    left: 10,
    transition: 'all 0.3s ease'
  },
  labelFocused: {
    backgroundColor: 'white',
    position: 'absolute',
    paddingLeft: 5,
    paddingRight: 5,
    top: -15,
    left: 8,
    transition: 'all 0.3s ease'
  }
};

const { RangePicker } = DatePicker;

export const FancyDateRangePicker: FC<FancyDateRangePickerProps> = ({
  rangeValues,
  placeHolder,
  onInputChange,
  onCalendarChange,
  disabled,
  width,
  defaultValue,
  format
}: FancyDateRangePickerProps) => {
  const [isLabelTop, _setIsLabelTop] = useState(false);

  const inputRef = useRef(null);

  const inputWidth = width ? { ...styles.input, ...{ width } } : styles.input;

  const handleFocus = (): void => {
    _setIsLabelTop(true);
  };

  const onLabelClick = (): void => {
    if (!isLabelTop) {
      _setIsLabelTop(true);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (inputRef.current as any).focus();
    }
  };

  const handleBlur = (): void => {
    if (!rangeValues.length) {
      _setIsLabelTop(false);
    }
  };

  return (
    <div style={{ ...styles.form, ...styles.borderAnimation }}>
      <RangePicker
        ref={inputRef}
        style={inputWidth}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onChange={onInputChange}
        onCalendarChange={onCalendarChange}
        format={format}
        disabled={disabled ? disabled : false}
        allowClear
      />
      <label style={styles.labelFocused} onClick={onLabelClick}>
        <span>{placeHolder}</span>
      </label>
    </div>
  );
};
